const constructionManagementEn = {
    constructionStage: require('../../lang/en/construction_management/ConstructionStage').default,
    construction: require('../../lang/en/construction_management/Construction').default,
    constructionDailyLog: require('../../lang/en/construction_management/ConstructionDailyLog').default,
};

export default constructionManagementEn;
